// Copyright (c) 2020 Deere & Company

import 'react-datepicker/dist/react-datepicker.css';
import React, {PropTypes} from 'react';
import {
    getCorrectDateValue,
    transformDateValue
} from '../../../shared/services/build-date';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import WarrantyDatePicker from '../../../shared/components/warranty-date-picker';

const handleDamageDateChange = props => newDate => props.onItemChange('damageEventDate', getCorrectDateValue(newDate));

const DamageDate = props => <div className='labeled-string'>
    <span className='data-label'>
        {<sup>{'*'}</sup>} <FormattedMessage id='DATE_OF_EVENT_CAUSING_DAMAGE'/>
    </span>
    <div className={'date-picker'}>
        <WarrantyDatePicker
            onChange={handleDamageDateChange(props)}
            selected={transformDateValue(props.statusChangeRequest.damageEventDate)}

        />
    </div>
</div>;

DamageDate.displayName = 'DamageDate';
DamageDate.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default DamageDate;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/damage-date.js